import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  CausersType,
  EventsType,
  SubjectType,
  UserLogsActivitiesType,
} from './types'
import { FormValuesType } from '~/features/user-logs-activities/ui/filter'

export class LogsActivitiesServices {
  static getLogsActivities(
    config?: AxiosRequestConfig<FormValuesType>,
  ): Promise<AxiosResponse<UserLogsActivitiesType[]>> {
    return apiService.get('/activities', config)
  }

  static getSubjects(): Promise<AxiosResponse<SubjectType[]>> {
    return apiService.get('/activities/subjects')
  }

  static getEvents(subjectType: string): Promise<AxiosResponse<EventsType[]>> {
    return apiService.get('/activities/subjects/events', {
      params: {
        subjectType: subjectType || null,
      },
    })
  }

  static getCausers(): Promise<AxiosResponse<CausersType[]>> {
    return apiService.get('/activities/causers')
  }
}
